import { useEffect } from 'react'
import { defer, from } from 'rxjs'
import { loginWithCredentials, useAuthCallback } from '../../auth'
import { setLoginFactory } from '../request/login-after'

export function useSetLoginFactory(): void {
  const { getLoginRedirectUrl } = useAuthCallback()
  useEffect(() => {
    setLoginFactory(({ email, password }) =>
      defer(() =>
        from(
          loginWithCredentials({
            email,
            password,
            redirectUri: getLoginRedirectUrl(),
          })
        )
      )
    )
  }, [getLoginRedirectUrl])
}
